var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.mobileSearch = {
	appendSearch: function() {
		var $html = $('<div id="searchBoxMobile" role="search"></div>'),
			$mSearchBox = $('#searchForm').clone().removeAttr('id');
		$html.append($mSearchBox);
		$header = $('header');
		$html.appendTo($header);

		$('[id]', $mSearchBox).each(function() {
			var $this = $(this),
				$id = $this.attr('id'),
				$newId = 'm'+$id.substr(0,1).toUpperCase()+$id.substr(1),
				$label = $('label[for="'+$id+'"]', $mSearchBox);

			if ($label.length > 0) {
				$label.attr('for', $newId);
			}
			$this.attr('id', $newId);
		});
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]').each(function() {
			var $img = $(this);
			$.get($img.attr('src'), function(data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function() {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
	}
};

site.calendar = {
	boxes: function() {
		site.dataFilter.init('.calFilter ul', '.events__by__months', '#mobileFilter');
	}
};
site.frontpage = {
	init: function() {
		$('.image.loading').bgLoaded();

		if ($('#banner .item').length > 1) {
			site.owl.init('#banner .items', {
				items: 1,
				nav: false,
				dots: true,
				autoplay: true,
				autoplayTimeout: 8000,
				smartSpeed: 800,
				autoplayHoverPause: true,
				loop: true,
			});
			$('.owl-dots', '#banner').addClass('contentWrap');
		}
	}
};

site.banner = {
	init: function() {
		$('.image', '#banner').bgLoaded();
	}
};

site.siteScroll = {
	init: function() {
		const body = document.body;
		const scrollUp = 'scrollUp';
		const scrollDown = 'scrollDown';
		const sticky = 'sticky';
		const stickyNoTranslate = 'stickyNoTranslate';
		const navbarHeight = 126;
		let lastScroll = 0;

		window.addEventListener('scroll', () => {
			if (document.body.clientWidth + 15 <= 991) {
				return;
			}

			const currentScroll = window.pageYOffset;
			if (currentScroll === 0) {
				body.classList.remove(scrollUp);
				body.classList.remove(sticky);
				return;
			}

			if (currentScroll > navbarHeight && !body.classList.contains(sticky)) {
				body.classList.add(sticky);
				body.classList.add(stickyNoTranslate);

				setTimeout(function() {
					body.classList.remove(stickyNoTranslate);
				},400);
			}
			else if (currentScroll < 10) {
				body.classList.remove(sticky);
			}

			// down
			if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
				body.classList.remove(scrollUp);
				body.classList.add(scrollDown);
			}
			// up
			else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
				body.classList.remove(scrollDown);
				body.classList.add(scrollUp);
			}
			lastScroll = currentScroll;
		});
		window.dispatchEvent(new CustomEvent('scroll'));
	}
};


// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.svg.init();
	site.mobileSearch.appendSearch();
	site.headSearch.init();
	site.labelFocus.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}
	if ($body.is('.hasBanner')) {
		site.banner.init();
	}

	site.siteScroll.init();

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', 'main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	$('.shareThis').click(function(e) {
		e.preventDefault();
		var width = ($(this).data('width') !== undefined) ? $(this).data('width') : 550;
		var height = ($(this).data('height') !== undefined) ? $(this).data('height') : 500;
		popCenter($(this).attr('href'), 'shareWindow', width, height);
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', 'main').wrap('<div class="table-responsive"></div>');
	}

	$body.removeClass("preload");

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});

function popCenter(url, title, w, h) {
	var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
	var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

	var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
	var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

	var left = ((width / 2) - (w / 2)) + dualScreenLeft;
	var top = ((height / 2) - (h / 2)) + dualScreenTop;
	var newWindow = window.open(url, title, 'scrollbars=0, toolbar=0, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

	// Puts focus on the newWindow
	if (window.focus) {
		newWindow.focus();
	}
}
